import { BEDROOM_OPTIONS } from '@propertypal/shared/src/constants/filterOptions';
import { UseSearchState } from '@propertypal/shared/src/hooks/useSearchState';
import { SearchState } from '@propertypal/shared/src/reducers/search';
import { formatBedsValue } from '@propertypal/shared/src/utils/search/inputFormating';
import SelectInput from '@propertypal/web-ui/src/inputs/SelectInput';
import React, { FunctionComponent } from 'react';

interface Props {
  filters: SearchState['filters'];
  handleFilterChange: UseSearchState['handleFilterChange'];
}

const BedInputs: FunctionComponent<Props> = ({ filters, handleFilterChange }) => {
  return (
    <>
      <SelectInput
        ariaLabel="Choose minimum bedrooms"
        id="minBedsSelect"
        containerStyle={{ marginRight: 15 }}
        label="Bedrooms"
        onChange={handleFilterChange('minBeds')}
        options={BEDROOM_OPTIONS('min', 'minimum')}
        placeholder="Minimum Beds"
        value={filters.minBeds}
        testID="minBedsSelect"
        wildcard={formatBedsValue}
      />

      <SelectInput
        ariaLabel="Choose maximum bedrooms"
        id="maxBedsSelect"
        label="&nbsp;"
        onChange={handleFilterChange('maxBeds')}
        options={BEDROOM_OPTIONS('max', 'maximum')}
        placeholder="Maximum Beds"
        value={filters.maxBeds}
        testID="maxBedsSelect"
        wildcard={formatBedsValue}
      />
    </>
  );
};

export default BedInputs;
